import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { agentApi } from "../../services/agentApi";

export default function AppointmentDrawer({ appointmentId, onClose, onCancelled }) {
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!appointmentId) return;
    setLoading(true);
    agentApi.appointments.get(appointmentId)
      .then((r) => setAppointment(r.appointment))
      .catch((err) => setError(err.message || "Erro ao carregar"))
      .finally(() => setLoading(false));
  }, [appointmentId]);

  async function handleCancel() {
    if (!confirm("Cancelar esta reunião? O slot será liberado.")) return;
    setCancelling(true);
    try {
      await agentApi.appointments.cancel(appointmentId, reason || undefined);
      onCancelled && onCancelled();
      onClose && onClose();
    } catch (err) {
      alert(`Erro ao cancelar: ${err.message || "desconhecido"}`);
    } finally {
      setCancelling(false);
    }
  }

  if (!appointmentId) return null;

  return (
    <div className="fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-2xl border-l border-gray-200 z-40 overflow-y-auto">
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">Detalhes da reunião</h2>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl">×</button>
      </div>

      {loading ? (
        <div className="p-6 text-gray-500">Carregando...</div>
      ) : error ? (
        <div className="p-6 text-red-600">{error}</div>
      ) : !appointment ? null : (
        <div className="p-4 space-y-4">
          <div>
            <div className="text-xs uppercase text-gray-500 font-medium">Lead</div>
            <div className="text-gray-900 font-semibold">{appointment.session?.lead?.name}</div>
            <div className="text-sm text-gray-600">{appointment.session?.lead?.phone}</div>
            {appointment.session?.lead?.processId && (
              <div className="text-sm text-gray-600 font-mono mt-1">
                {appointment.session.lead.processId}
              </div>
            )}
          </div>

          <div>
            <div className="text-xs uppercase text-gray-500 font-medium">Quando</div>
            <div className="text-gray-900">
              {new Date(appointment.slot.startAt).toLocaleString("pt-BR", {
                weekday: "long", day: "2-digit", month: "2-digit", year: "numeric",
                hour: "2-digit", minute: "2-digit",
              })}
            </div>
          </div>

          <div>
            <div className="text-xs uppercase text-gray-500 font-medium">Trader</div>
            <div className="text-gray-900">{appointment.trader?.user?.name}</div>
          </div>

          <div>
            <div className="text-xs uppercase text-gray-500 font-medium">Status</div>
            <div className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${
              appointment.status === "SCHEDULED" ? "bg-blue-100 text-blue-700"
              : appointment.status === "CANCELLED" ? "bg-red-100 text-red-700"
              : "bg-gray-100 text-gray-700"
            }`}>
              {appointment.status}
            </div>
          </div>

          <div className="pt-3 border-t border-gray-200">
            <Link
              to={`/atendimento/conversas?session=${appointment.sessionId}`}
              className="text-blue-600 hover:text-blue-700 text-sm font-medium"
            >
              → Abrir conversa do lead
            </Link>
          </div>

          {appointment.status === "SCHEDULED" && (
            <div className="pt-3 border-t border-gray-200 space-y-2">
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Motivo do cancelamento (opcional)"
                rows={2}
                className="w-full px-2 py-1 bg-white border border-gray-300 text-gray-900 rounded text-sm"
              />
              <button
                onClick={handleCancel}
                disabled={cancelling}
                className="w-full py-2 bg-red-600 hover:bg-red-700 disabled:bg-gray-300 text-white rounded font-medium text-sm"
              >
                {cancelling ? "Cancelando..." : "Cancelar reunião"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
